import Const from "../constant/Const";

let forge = require('node-forge');

export function encryptDataWithPublicKey(data) {
    return data;
}

